<template>
  <img src="/images/mid-back.png">
</template>

<script>
export default {
  name: "MidBack"
}
</script>
